// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  cascaderAreas: [],
}

// getters
const getters = {
  // user: state => state.user
}

// actions
const actions = {
  getProvinces ({commit, state}, params) {
    return request.alert('getProvinces', params)
  },
  getCities ({commit, state}, params) {
    return request.alert('getCities', params)
  },
  getDistricts ({commit, state}, params) {
    return request.alert('getDistricts', params)
  },
}

// mutations
const mutations = {
  SET_AREA_CASCADER_AREAS (state, value) {
    state.cascaderAreas = value
  },
}

export const area = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/area/area.store.js